import api from './api';

export interface InvoiceDeliveryRow {
  bill_id: string;
  invoice_number: string;
  state: 'pending' | 'retry' | 'stored' | 'skipped' | 'blocked';
  attempts: number;
  stored_files: number;
  last_error: string | null;
  last_attempt_at: string | null;
  next_attempt_at: string;
}
export interface InvoiceLedger {
  rows: InvoiceDeliveryRow[];
  enabled: boolean;
  start_date: string | null;
  selection_id: string | null;
}
export interface InvoiceRunResult {
  status: string;
  records: number;
  updated: number;
  errors: number;
  more_pages?: boolean;
}
const base = '/admin/axle-invoices';
export default {
  async list(): Promise<InvoiceLedger> { return (await api.get(base)).data; },
  async scan(): Promise<InvoiceRunResult> { return (await api.post(`${base}/scan`)).data; },
  async run(): Promise<InvoiceRunResult> { return (await api.post(`${base}/run`, undefined, { timeout: 300000 })).data; },
  async retry(billId: string): Promise<{ status: string }> {
    return (await api.post(`${base}/${encodeURIComponent(billId)}/retry`)).data;
  },
};
